<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        v-if="!editable && editMode"
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Disability') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">

      <form v-on:submit.prevent="save(candidateEdit)">
        <div class="form-group">
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="hearing" value="hearing" v-model="candidateEdit.disability">
              <label class="form-check-label" for="hearing">{{ $t('Hearing') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="vision" value="vision" v-model="candidateEdit.disability">
              <label class="form-check-label" for="vision">{{ $t('Visual') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="intellectual" value="intellectual" v-model="candidateEdit.disability">
              <label class="form-check-label" for="intellectual">{{ $t('Intellectual') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="physical" value="physical" v-model="candidateEdit.disability">
              <label class="form-check-label" for="physical">{{ $t('Physical') }}</label>
            </div>
          </div>
          <ValidateMessage :error="validateErrors.disability" />
        </div>

        <div
          class="form-group"
          v-if="candidateEdit.disability.length">
          <textarea class="form-control" type="text" v-model="candidateEdit.disability_comment" placeholder="Descreva suas condições especiais"></textarea>
          <ValidateMessage :error="validateErrors.disability_comment" />
        </div>

        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>

    </div>
    <div
      v-if="!editable && filled"
      class="card-body">
        <strong>{{ disability }}</strong>
        <div>{{ candidate.disability_comment }}</div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CandidateProfileDetails',
  components: {
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    filled () {
      return this.candidate.disability && this.candidate.disability.length
    },
    disability () {
      return this.candidate.disability.map((val) => {
        return {'hearing': this.$t('Hearing'), 'vision': this.$t('Visual'), 'intellectual': this.$t('Intellectual'), 'physical': this.$t('Physical')}[val]
      }).join(', ')
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = {
        _id: this.candidate._id,
        disability: Array.isArray(this.candidate.disability) ? this.candidate.disability : {},
        disability_comment: this.candidate.disability_comment
      }
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileDisability.vue